<template src="./html/Index.html"></template>
	
<script>
	import swal from 'sweetalert2'
	export default {
		props: ['user', 'isAuth', 'task', 'staff'],
		data () {
			return {
				data: null,
				event: null,
			}
		},
		created () {
			this.init()
		},
		mounted() {
			this.calendar()
		},
		methods: {
			init() {
				this.getData()
			},
			reload() {
				this.$emit('reload')
				this.getData()
			},
			//-- Función para inicializar fullCalendar usando jQuery y los scripts de la plantilla
			calendar() {
				var that = this
				var calendar = $('#calendar').fullCalendar({
					textEscape: false,
					header: {
						left: 'month,basicWeek,basicDay',
					},
					defaultView: 'basicWeek',
					displayEventEnd: true,
					displayEventTime: true,
					events: [],
					lang: 'es',
					timeFormat: 'H:mm',
					eventClick:  function(event, jsEvent, view) {
						that.event = event
						$('#event').modal()
					},
					eventRender: function(event, element) {
						element.empty()
						element.append('<span><b>' + event.title + '</b></span><br>')
						if(event.customer) {
							element.append('<span><b>' + event.customer.name + '</b></span><br>')
						}
						if(event.start && event.end) {
							element.append('<span>' + moment(event.start).format('H:mm') + ' - ' + moment(event.end).format('H:mm') + '</span><br>')
						} else {
							if(event.start) {
								element.append('<span>' + moment(event.start).format('H:mm') + '</span><br>')
							}
						}
					},
				})
				if(this.task) {
					if(this.task.schedules.length) {
						var schedule = this.task.schedules[0]
						calendar.fullCalendar('gotoDate', schedule.estimated_start)
					}
				}
			},
			getData: function() {
				var api = 'admin/projects/schedules'
				if(this.task) {
					api = 'admin/projects/tasks/'+this.task.id+'/schedules'
				}
				if(this.staff) {
					api = 'admin/users/'+this.staff.id+'/schedules'
				}
				this.$http.get(api)
					.then(response => {
						this.data = response.body
						this.$nextTick( () => this.loadEvents())
					})
			},
			loadEvents() {
				if(this.data) {
					$('#calendar').fullCalendar('removeEvents', {
						displayEventEnd: false,
					})
					this.data.forEach(function(element) {
						var customer = null
						if(element.task) {
							if(element.task.customers) {
								if(element.task.customers.length) {
									customer = element.task.customers[element.task.customers.length - 1]
								}
							}
						}

						var event = {
							textEscape: false,
							title: element.task.name,
							start: element.estimated_start,
							end: element.estimated_end,
							allDay: false,
							className: 'bg-' + element.task.status.class,
							/// task data
							schedule: element,
							customer: customer,
						}
						$('#calendar').fullCalendar('renderEvent', event, true)
					})
				}
			},
			deleteSchedule(schedule, event) {
				var that = this

				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.item_can_not_be_retrieved"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.delete('admin/projects/schedules/' + schedule.id)
							.then(response => {
								swal({
									title: response.body.title,
									text: response.body.text,
									type: response.body.type
								})
								$('#event').modal('toggle')
								that.$emit('reload')
								$('#calendar').fullCalendar('removeEvents',event._id)
							}).catch(function(response) {
								console.log(response)
								swal({
									title: response.statusText,
									text: response.body,
									type: "warning",
								})
							})
						})
					}
				}]).catch(swal.noop)
			},
			push: function(url) {
				$('#event').modal('toggle')
				this.$router.push('/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/projects' + url)
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/projects/calendar/views/Index.vue